// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
    position: sticky;
    top: 0;
}

.layout-news-active :host ::ng-deep .p-datatable tr > th {
    top: 0;
}

@media screen and (max-width: 64em) {
    :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
        top: 0;
    }

    .layout-news-active :host ::ng-deep .p-datatable tr > th {
        top: 0;
    }
}

.iconDIV {
    display: flex;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/controls/tables/datatable/datatable.control.css"],"names":[],"mappings":"AAAA;IAEI,gBAAgB;IAChB,MAAM;AACV;;AAEA;IACI,MAAM;AACV;;AAEA;IACI;QACI,MAAM;IACV;;IAEA;QACI,MAAM;IACV;AACJ;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B","sourcesContent":[":host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n}\n\n.layout-news-active :host ::ng-deep .p-datatable tr > th {\n    top: 0;\n}\n\n@media screen and (max-width: 64em) {\n    :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {\n        top: 0;\n    }\n\n    .layout-news-active :host ::ng-deep .p-datatable tr > th {\n        top: 0;\n    }\n}\n\n.iconDIV {\n    display: flex;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
